var map = {
	"./icon-calendar.svg": "6f1e",
	"./icon-error.svg": "9a58",
	"./icon-external-url.svg": "f336",
	"./icon-hint.svg": "aaef",
	"./icon-speech-bubble.svg": "d4e5",
	"./icon-table.svg": "719f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c844";